var React = require('react');

function Freighter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Capital Industrial"),React.createElement("g",{"id":"g1405","key":2},[React.createElement("path",{"id":"path1191-9-1-7-3","className":"cls-1","d":"M114,27.5,97.33,10.83H30.67L14,27.5V85.83L30.67,69.17H97.33L114,85.83Z","key":0}),React.createElement("path",{"id":"path1273","className":"cls-1","d":"M39,85.83H89l16.67,16.67L89,119.17H39L22.33,102.5Z","key":1})])]);
}

Freighter.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Freighter;

Freighter.default = Freighter;
